export const COMPILATION_REQUIRED = "COMPILATION_REQUIRED";
export const COMPILATION_IN_PROGRESS = "COMPILATION_IN_PROGRESS";
export const COMPILATION_FAILED = "COMPILATION_FAILED";
